var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Gallery',{attrs:{"title":"Your Opportunity","subtitle":"Contribution","images":[
    {
        title:'SOFI Stadium',
        file:'contribution.jpg'
    }        
    ]}}),_c('section',{staticClass:"contribution"},[_c('Packages',{on:{"packageSelected":_vm.setSite}})],1),_c('ContributionCalculator',{attrs:{"isLeader":_vm.isLeader,"donation":_vm.donation,"total":_vm.total,"signing":_vm.signing,"p0":_vm.p0,"p1":_vm.p1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }